import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jira-bug",
  "use": "icon-jira-bug-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" role=\"presentation\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jira-bug\">\n    <path fill=\"#FF5630\" fill-rule=\"evenodd\" d=\"M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm9 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol